import { Database } from 'database';

export async function migratoToVersion8(context: Database, transaction: IDBTransaction) {
  var hasAuthSettings = await context.read(context.config.indexes.Tenant, 'HAS_AUTH_SETTINGS', transaction);
  var hasEnterpriseLogin = await context.read(context.config.indexes.Tenant, 'HAS_ENTERPRISE_LOGIN', transaction);
  if (hasAuthSettings !== null && hasEnterpriseLogin === null) {
    await context.add(context.config.indexes.Tenant, 'HAS_ENTERPRISE_LOGIN', '', transaction);
  }
}



// WEBPACK FOOTER //
// ./src/migrations/1.4-to-1.5.ts